export const firstString = (v?: string | string[]) =>
  Array.isArray(v) ? v.find(Boolean) ?? "" : v ?? "";

export const buildWhatsAppHref = (
  whats?: string,
  phones?: string | string[],
  text?: string
) => {
  if (whats && /^(https?:\/\/|whatsapp:\/\/)/i.test(whats)) {
    return text
      ? `${whats}${whats.includes("?") ? "&" : "?"}text=${encodeURIComponent(
          text
        )}`
      : whats;
  }
  const raw = whats || firstString(phones);
  const digits = (raw ?? "").replace(/\D/g, "");
  const base = digits ? `https://wa.me/${digits}` : "https://wa.me/";
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};
